import React from 'react'
import { Dimmer, Loader } from 'semantic-ui-react'
import styled from 'styled-components'
import { CoolFarmCropEl } from './style'

interface Props {
  step: {
    icon?: string,
    title: string
    image?: string
    style?: any
  }
  active: boolean
  index: number
  isLoading?: boolean
  handleStepClick: () => void
}

const StyledWrapper = styled.div<{ $active: boolean }>`
display: flex;
flex-direction: column;
align-items: center;
width: 150px;
`

const StyledDimmer = styled(Dimmer)`
margin-left: -3px !important;
background: transparent !important;
color: white;
 .loader {
    &:after {
      border-color: none !important;
    }
 }
`

const Step: React.FC<Props> = (props) => {

  const {
    step,
    active,
    index,
    isLoading,
    handleStepClick
  } = props

  function renderSpinner() {

    return (
      <StyledDimmer
        inverted
        active={isLoading}
    >
        <Loader active={isLoading} />
      </StyledDimmer>
    )
  }

  function renderIcon() {
    return (
      <div>
        <img src={step.image} style={props.step.style} />
      </div>
    )
  }

  function renderStepContent() {
    return (
      <StyledWrapper
        onClick={() => handleStepClick()}
        $active={active}
    >
        <CoolFarmCropEl.StepIcon
          $active={active}
      >
          {isLoading ? renderSpinner() : renderIcon()}
        </CoolFarmCropEl.StepIcon>
        <div
          className='stepTitle'>
          {step.title}
        </div>
      </StyledWrapper>
    )
  }

  return (
    <CoolFarmCropEl.Step key={step.icon} $active={active} data-step={index}>
      {renderStepContent()}
    </CoolFarmCropEl.Step>
  )
}
export default Step
